
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Button } from 'element-ui';
import tIcon from '@/components/Icon/icon.vue';
import { IBTNCONF } from '@/types/base.d';

@Component({
  components: {
    Button,
    tIcon,
  },
})
export default class tAction extends Vue {
  @Prop({
    required: true,
  }) btns!: Array<IBTNCONF>;
}
